module.exports = __webpack_public_path__ + "img/Text_SZPX_W.959bee58.png";